import type { ReactElement } from 'react';
import { cn } from '@/lib/utils';

interface StepProgressProps {
    current: number;
    total?: number;
}

export default function StepProgress({ current, total = 3 }: StepProgressProps): ReactElement {
    const clamped = Math.min(Math.max(current, 1), total);

    return (
        <div className="mb-6" aria-hidden="true">
            <div className="flex gap-1.5">
                {Array.from({ length: total }, (_, index) => (
                    <div
                        key={index}
                        className={cn(
                            'h-0.5 flex-1 bg-border motion-safe:transition-colors motion-safe:duration-200',
                            index < clamped && 'bg-foreground'
                        )}
                    />
                ))}
            </div>
        </div>
    );
}
